import { useLocale } from "@outschool/localization";
import { useQueryWithPreviousData } from "@outschool/ui-apollo";

import {
  ContentfulCategoryPageQuery,
  ContentfulCategoryPageQueryVariables,
  ContentfulCategoryPageRelatedCarouselsQuery,
  ContentfulCategoryPageRelatedCarouselsQueryVariables,
  ListAllCuratedCategoryPagesQuery,
  ListAllCuratedCategoryPagesQueryVariables,
} from "../../shared/generated/graphql";
import {
  CuratedCategoryPageQuery,
  CuratedCategoryPageRelatedCarouselsQuery,
  listAllCuratedCategoryPagesQuery,
} from "../queries/CuratedCategoryPageQuery";

export function useCuratedCategoryPageQuery({
  categorySlug,
  preview,
}: {
  categorySlug: string;
  preview?: boolean;
}) {
  const locale = useLocale();

  return useQueryWithPreviousData<
    ContentfulCategoryPageQuery,
    ContentfulCategoryPageQueryVariables
  >(CuratedCategoryPageQuery, {
    variables: { categorySlug, locale, preview },
  });
}

export function useCuratedCategoryPageRelatedCarouselsQuery({
  categorySlug,
  preview,
}: {
  categorySlug: string;
  preview?: boolean;
}) {
  const locale = useLocale();

  return useQueryWithPreviousData<
    ContentfulCategoryPageRelatedCarouselsQuery,
    ContentfulCategoryPageRelatedCarouselsQueryVariables
  >(CuratedCategoryPageRelatedCarouselsQuery, {
    variables: { categorySlug, locale, preview },
  });
}

export function useCuratedPageSlugsQuery() {
  return useQueryWithPreviousData<
    ListAllCuratedCategoryPagesQuery,
    ListAllCuratedCategoryPagesQueryVariables
  >(listAllCuratedCategoryPagesQuery);
}
